module.exports = __webpack_public_path__ + "static/img/ccpt1.fa150dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/ccpt/ccpt1.jpg
// module id = 4GXI
// module chunks = 0